import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import footerLogo from "@/assets/images/fooer-logo.png";
import styles from "@/styles/houseOfSenco.module.scss";
import Link from "next/link";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footer_logo}>
          <Image src={footerLogo} alt="Senco Gold & Diamonds Footer Logo" />
        </div>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <p>Customer Support</p>
            <p>We are happy to help you with your purchase</p>
            <div className={styles.quick_link}>
              <ul className="mt-4 mb-4">
                <li>
                  <a> Call 1800-103-0017</a>
                </li>
              </ul>
              <ul>
                <li>
                  <Link passHref href={"/about-us"}>
                    <a> About Us</a>
                  </Link>
                </li>
                <li>
                  <a>The House Of Senco</a>
                </li>
                {/* <li>
                  <Link passHref href={"/privacy-policy"}>
                    <a>Careers</a>
                  </Link>
                </li>
                <li>
                  <Link passHref href={"/privacy-policy"}>
                    <a>Feedback</a>
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles.quick_link}>
              <ul>
                <li>
                  <Link passHref href={"/faq"}>
                    <a> FAQs</a>
                  </Link>
                </li>
                <li>
                  <Link passHref href={"/offers-terms-condition"}>
                    <a>Offers Terms & Conditions</a>
                  </Link>
                </li>
                <li>
                  <Link passHref href={"/shipping-policy"}>
                    <a>Shipping Policy</a>
                  </Link>
                </li>
                <li>
                  <Link passHref href={"/return-and-refund-policy"}>
                    <a> Return / Exchange Policy</a>
                  </Link>
                </li>
                {/* <li>
                  <Link passHref href={"/faq"}>
                    <a> Site Map</a>
                  </Link>
                </li> */}
                <li>
                  <Link passHref href={"/offers-terms-condition"}>
                    <a>Terms of Use</a>
                  </Link>
                </li>
                <li>
                  <Link passHref href={"/customer-service"}>
                    <a> Customer Services</a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.footer_bottom}>
          <ul>
            <li>
              <a>© 2024, House of Senco ( A Senco Gold Limited Company )</a>
            </li>
            <li>
              <a>All Rights Reserved. </a>
            </li>
            <li>
              <Link passHref href={"/offers-terms-condition"}>
                <a> Terms & Conditions </a>
              </Link>
            </li>
            <li>
              <Link passHref href={"/privacy-policy"}>
                <a> Privacy Policy </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
